import React from 'react'
import RSVMain from '../components/rsv-testing/RSVMain'
import RSVTests from '../components/rsv-testing/RSVTests'
import RSVTesting from '../components/rsv-testing/RSVTesting'
import RSVSymptoms from '../components/rsv-testing/RSVSymptoms'
import RSVInChildren from '../components/rsv-testing/RSVInChildren'
import RSVOverallPerformance from '../components/rsv-testing/RSVOverallPerformance'
import RSVFastEasyTest from '../components/rsv-testing/RSVFastEasyTest'
import RSVWeeklyDetectionRate from '../components/rsv-testing/RSVWeeklyDetectionRate'
import RSVTestWorking from '../components/rsv-testing/RSVTestWorking'
import RSVTestResults from '../components/rsv-testing/RSVTestResults'
import RSVNeedOfTest from '../components/rsv-testing/RSVNeedOfTest'
import MainHeader from '../layout/MainHeader'
import TopHeader from '../layout/TopHeader'
import Footer from '../layout/Footer'
import CopyRight from '../layout/CopyRight'
import MainResHeader from '../layout/MainResHeader'
import { useEffect } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const RSVTestingPage = () => {

  useEffect(()=>{
    window.scrollTo(0,0)
  },[])

  return (
    <div style={{ overflow:'hidden'}}>
    <HelmetProvider>
      <Helmet prioritizeSeoTags>
      <title>Fast and Comprehensive RSV Test In Chicago | United Lab Care</title>
      <meta name="description" content="Get fast and accurate RSV testing in Chicago at United Lab Care. Schedule your appointment today and get the answers you need." />
	<link rel="canonical" href="https://unitedlabcare.com/rsv-testing-in-chicago-il/" />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Fast and Comprehensive RSV Test In Chicago | United Lab Care" />
	<meta property="og:description" content="Get fast and accurate RSV testing in Chicago at United Lab Care. Schedule your appointment today and get the answers you need." />
	<meta property="og:url" content="https://unitedlabcare.com/rsv-testing-in-chicago-il/" />
	<meta property="og:site_name" content="United Lab Care" />
	<meta property="article:modified_time" content="2023-08-10T18:54:00+00:00" />
	<meta property="og:image" content="https://unitedlabcare.com/wp-content/uploads/2022/12/RSV-Testing-icon1-v1.png" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:label1" content="Est. reading time" />
	<meta name="twitter:data1" content="7 minutes" />
      </Helmet>
    </HelmetProvider>
        <TopHeader/>
        {/* <MainHeader/> */}
        <MainResHeader/>
        
        <RSVMain/>
        <RSVTests/>
        <RSVTesting/>
        <RSVSymptoms/>
        <RSVInChildren/>
        <RSVOverallPerformance/>
        <RSVFastEasyTest/>
        <RSVWeeklyDetectionRate/>
        <RSVTestWorking/>
        <RSVTestResults/>
        <RSVNeedOfTest/>

        <Footer/>
        <CopyRight/>
    </div>
  )
}

export default RSVTestingPage